/**
 * Advance a series date by one recurrence step using UTC arithmetic.
 *
 * Series dates are date-only strings parsed as UTC midnight and formatted with
 * toISOString (UTC), so stepping must also be UTC. Local-time stepping
 * (setDate/getDate) shifts the result by an hour across a DST change and the
 * date then formats one day early.
 *
 * Mutates and returns `date`.
 */
export const advanceSeriesDate = (date, recurrence) => {
    if (recurrence === 'daily') {
        date.setUTCDate(date.getUTCDate() + 1);
    } else if (recurrence === 'weekly') {
        date.setUTCDate(date.getUTCDate() + 7);
    } else if (recurrence === 'monthly') {
        date.setUTCMonth(date.getUTCMonth() + 1);
    }

    return date;
};
